<template>
  <table-publish-notify v-if="published" :unique-id="uniqueId" />
  <div v-else class="flex-fill flex flex-column" style="position: relative;">
    <div
      class="flex-auto flex flex-row bgc-white v-center"
      style="margin: 10px 0; padding: 5px 0;"
    >
      <div class="flex-fill v-center" style="padding: 0 10px;">
        <div class="flex flex-row v-center" style="padding: 5px;">
          <label style="flex: 0 0 75px;">标题: </label>
          <div>
            <el-input
              v-model="title"
              size="mini"
              placeholder="请输入标题"
              style="min-width: 700px;"
            />
          </div>
        </div>
        <div class="flex flex-row v-center" style="padding: 5px;">
          <label style="flex: 0 0 75px;">制表单位: </label>
          <div>{{ orgName }}</div>
        </div>
      </div>
      <div class="flex-auto v-center" style="padding: 15px;">
        <!--        <el-button round size="small" type="primary" @click="handleSave"-->
        <!--          >保存</el-button-->
        <!--        >-->
        <el-divider direction="vertical" />
        <el-button round size="small" type="primary" @click="handlePublish"
          >发布</el-button
        >
      </div>
    </div>
    <div class="flex-auto bgc-white" style="padding: 5px;">
      <!--      <el-button size="mini" :disabled="disableMerge" @click="handleMergeCell"-->
      <!--        >合并</el-button-->
      <!--      >-->
      <!--      <el-button-->
      <!--        size="mini"-->
      <!--        :disabled="disableCancelMerge"-->
      <!--        @click="handleCancelMerge"-->
      <!--        >取消合并</el-button-->
      <!--      >-->
      <el-button size="mini" :disabled="disableDelete" @click="handleDelete"
        >删除</el-button
      >
      <!--      <el-button size="mini" :disabled="disableInsert" @click="handleInsert"-->
      <!--        >插入</el-button-->
      <!--      >-->
      <el-button size="mini" :disabled="disableSetting" @click="handleShowModal"
        >属性设置</el-button
      >
    </div>
    <grid-excel
      :cells="designCells"
      :default-editor="defaultEditor"
      ref="gridExcel"
      class="flex-fill bgc-white"
      @cell-selected="handleRangeChange"
      @change-value="handleChangeValue"
      style="position: relative;"
    />
    <designer-template :visible.sync="visible.template" />
    <designer-configure
      :visible.sync="visible.configure"
      :value="cellConfigure"
      :load-title-parent-value="loadTitleParentValue"
      :load-title-parent-source="loadTitleParentSource"
      :load-answer-parent-source="loadAnswerParentSource"
      @ok="handleConfirmConfigure"
    />
  </div>
</template>
<script>
import GridExcel from "@/components/grid/GridExcel";
import { mockExcelRows } from "@/components/excel/utils/ConfigUtil.ts";
import { Button, Divider, Input, Message } from "element-ui";
import DesignerTemplate from "@/components/excel/designer/template/index";
import DesignerConfigure from "@/components/excel/designer/configure/index";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
  createConfigure,
  createDefaultEditor,
} from "@/utils/excel/ConfigureHelper";
import { CellPosition } from "@/components/excel/schema/BaseSchema.ts";
import { findParent as findTitleParent } from "@/components/excel/schema/label/type";
import { findParent as findAnswerParent } from "@/components/excel/schema/value/type";
import TablePublishNotify from "@/components/table/PublishNotify";
import { parseValue } from "@/store/modules/table/getters";
import store from "@/store";

export default {
  name: "add-table",
  components: {
    TablePublishNotify,
    DesignerConfigure,
    DesignerTemplate,
    GridExcel,
    [Input.name]: Input,
    [Divider.name]: Divider,
    [Button.name]: Button,
  },
  data() {
    const cells = mockExcelRows(10, 10);
    return {
      title: "",
      // cells,
      selected: {
        cell: new CellPosition(1, 1),
        isSingle: true,
      },
      visible: {
        configure: false,
        template: false,
      },
      cellConfigure: createConfigure(),
      defaultEditor: createDefaultEditor(),
      published: false,
      uniqueId: "",
    };
  },
  inject: ["app"],
  computed: {
    ...mapState({
      cells: (state) => state.table.cells,
    }),
    ...mapGetters({
      orgList: "user/orgList",
      designCells: "table/designCells",
      configMap: "table/configMap",
    }),
    orgName() {
      const identityId = this.app.identityIdProxy;
      console.log(identityId);
      const org = this.orgList.find((it) => `${it.id}` === `${identityId}`);
      return (org && org.name) || "";
    },
    selectedWholeColumn() {
      return this.selected.columns.length > 0;
    },
    selectedWholeRow() {
      return this.selected.rows.length > 0;
    },
    selectedRange() {
      return this.selected.cells.length > 1;
    },
    selectedMergedCell() {
      return this.selected.cells.some((it) => {
        return it.span && (it.span.rowSpan > 1 || it.span.colSpan > 1);
      });
    },
    selectedSingleCell() {
      if (
        this.selectedWholeRow ||
        this.selectedWholeColumn ||
        this.selectedRange
      ) {
        return false;
      }
      return this.selected.cells.length === 1;
    },
    disableMerge() {
      return this.selected.isSingle;
    },
    disableCancelMerge() {
      return this.selected.isSingle;
    },
    disableDelete() {
      return !this.selected.isSingle;
    },
    disableInsert() {
      return false;
    },
    disableSetting() {
      return !this.selected.isSingle;
    },
  },
  methods: {
    ...mapActions({
      save: "table/create",
      publish: "table/publish",
    }),
    ...mapMutations({
      updateTitleValue: "table/updateTitleValue",
      removeConfig: "table/removeConfig",
      updateConfig: "table/updateConfig",
    }),
    handleMergeCell() {
      const { gridExcel } = this.$refs;
      if (gridExcel) {
        gridExcel.mergeSelectedCells();
      }
    },
    handleCancelMerge() {
      const { gridExcel } = this.$refs;
      if (gridExcel) {
        gridExcel.cancelMergedCell();
      }
    },
    handleDelete() {
      // const { gridExcel } = this.$refs;
      // if (gridExcel) {
      //   gridExcel.deleteSelected();
      // }
      const { cell } = this.selected;
      this.removeConfig(cell);
    },
    handleInsert() {
      const { gridExcel } = this.$refs;
      if (gridExcel) {
        if (this.selectedWholeRow) {
          gridExcel.insertRow();
        } else if (this.selectedWholeColumn) {
          gridExcel.insertColumn();
        } else if (this.selectedSingleCell) {
          // 可以从上方插入 也可以从左边插入 所以此处应该弹窗 让选是从上方插入还是从左边插入
          gridExcel.insertCell();
        }
      }
    },
    handleShowModal() {
      this.visible.configure = true;
      const { cell } = this.selected;
      const key = `${cell.rowIndex}-${cell.columnIndex}`;
      const conf = this.configMap.get(key);
      this.cellConfigure = conf || createConfigure();
      console.log(key, conf);
    },
    handleRangeChange({ cell, isSingle }) {
      this.selected.cell = cell;
      this.selected.isSingle = isSingle;
    },
    handleConfirmConfigure(configure) {
      console.log(configure);
      const { cell } = this.selected;
      this.updateConfig({ ...configure, position: cell });
    },
    handleChangeValue(payload) {
      // console.log(payload);
      // this.updateTitleValue(payload);
      const { position, value, text } = payload;
        this.updateTitleValue({ position, text });
      // if (Array.isArray(value)) {
      //   this.updateTitleValue({ position, value: value.join(",") });
      // } else {
      //   this.updateTitleValue({ position, value: `${value}` });
      // }
    },
    async handleSave() {
      if (!this.title) {
        Message.error("请填写标题");
        return null;
      }
      if (!Array.isArray(this.cells) || !this.cells.length) {
        Message.error("请至少添加一个题目");
        return null;
      }
      const nonEmptyCells = this.cells.filter(
        (cell) => cell.bizType && (cell.bizValue || cell.displayText)
      );
      if (!nonEmptyCells.length) {
        Message.error("请至少添加一个有效的题目");
        return null;
      }
      const payload = {
        cells: nonEmptyCells,
        title: this.title,
        dimension: 1,
      };
      return await this.save(payload);
    },
    async handlePublish() {
      const uniqueId = await this.handleSave();
      if (uniqueId) {
        const success = await this.publish({ uniqueId });
        if (success) {
          this.published = true;
        }
        this.uniqueId = uniqueId;
        // this.$router.push({
        //   name: "answerTable",
        //   params: { uniqueId }
        // });
      }
    },
    loadTitleParentValue(position) {
      if (!position) {
        return null;
      }
      const cell = this.cells.find((it) => it.position.isSameCell(position));
      if (cell) {
        return parseValue(cell.inputMode, cell.bizValue);
      }
      return null;
    },
    async loadTitleParentSource(type) {
      const parentType = findTitleParent(type);
      return this.cells
        .filter((it) => it.bizType === parentType)
        .map((it) => it.position);
    },
    async loadAnswerParentSource(type) {
      const parentType = findAnswerParent(type);
      console.log("answer的parent type", type, parentType);
      return this.cells
        .filter((it) => {
          if (!it.answerConfigure) {
            return false;
          }
          const { bizType } = it.answerConfigure;
          return bizType === parentType;
        })
        .map((it) => it.position);
    },
  },
  beforeRouteEnter(to, from, next) {
    const { commit } = store;
    commit("table/cleanAll");
    next();
  },
};
</script>
